import styled, { css } from 'styled-components';

export const SidebarContainer = styled.div<{ isOpen: boolean }>`
  flex: 0 0 100%;
  width: ${({ isOpen }) => (isOpen ? '230px' : '72px')}; /* Set the width based on isOpen state */ //21-Mar-2024 (isOpen ? '290px' : '90px')
  min-width: ${({ isOpen }) => (isOpen ? '230px' : '72px')}; /* Minimum width for responsiveness */ //21-Mar-2024 (isOpen ? '290px' : '90px')
  height: 100%;
  background-color: black;
  color: #fff;
  padding: 20px 0px;
  position: fixed;
  top: 0;
  left: 0;
  transition: width 0.2s ease;
  height: 100vh;
  overflow: visible;
  
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: gray;
  }

  &::-webkit-scrollbar {
    width: 5px;
    background-color: red;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0afc7f;
    border: 0px solid yellow;
  }

  // .main-sidebar-top-menu{
  //   height : ${({ isOpen }) => (isOpen ? 'calc(100vh - 540px)' : 'calc(100vh - 395px)')}; 
  // }

  
  @media screen and (max-width: 768px) {
    width: ${({ isOpen }) => (isOpen ? '200px' : '60px')}; /* Adjust width for smaller screens */
    min-width: ${({ isOpen }) => (isOpen ? '200px' : '60px')}; /* Minimum width for responsiveness */
    flex: 0 0 100%;
    height: calc(100vh - 0px);
    height: calc(100vh - 0px);
  }
  
  
`;

export const SidebarHeader = styled.div`
  display: flex; align-items: center;
  display: flex; align-items: center;
  cursor: pointer;
`;

export const SidebarTitle = styled.h3<{ isOpen: boolean }>`
  margin: 0;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')}; /* Hide the title when sidebar is closed */
  padding: '0px 70px'; //21-Mar-2024 0px 30px
  font-family: 'Aeonik';
`;

  export const SidebarList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin-bottom: auto;
    height: calc(100vh - 220px);
    overflow: auto;
    position: relative;
    overflow-x: clip;
    // @media(max-width: 1366px){
    //   height: calc(100vh - 280px);
    // }
    // @media(max-width: 1365px){
    //   height: calc(100vh - 170px);
    // }
    // &:before {
    //   content: '';
    //   position: absolute;
    //   left: 7px;
    //   bottom: 0px;
    //   right: 0px;
    //   margin: 0 auto;
    //   width: 48px;
    //   background: #808080;
    //   z-index: 999999;
    //   opacity: 1;
    //   height: 1px;
    // }
  }
`;

export const SidebarBottomList = styled.ul`
  list-style-type: none;
  padding: 0;
 
 
  bottom: 20px;


  &:hover {
    .sc-kFCroH {
      filter: none !important;
    }
  }
`;

// Styled component for the image
export const SidebarImage = styled.img<{ isOpen: boolean }>`
  left: ${({ isOpen }) => (isOpen ? '15px' : '15px')}; //21-Mar-2024 (isOpen ? '240px' : '15px')
  z-index: 9999;
  width: 32px;
  height: 32px;
  padding: 0px; 
  margin: 0px 20px;
  @media screen and (max-width: 992px) {
    margin: 0px 10px
  }
`;

export const SidebarItemContainer = styled.li<{ isActiveMenu?: boolean }>`
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  background-color: ${({ isActiveMenu }) =>
        isActiveMenu ? 'var(--Cool-Grey-cool-grey-300, #313233);' : 'transparent'};
  &:hover {
    background: var(--Cool-Grey-cool-grey-400, #1B1B1B);
  }
  cursor: pointer;
  @media screen and (max-width: 768px) {
    margin-bottom: 5px;
  }
`;

export const IconContainer = styled.div<{ hover: boolean }>`
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  position: relative;
    //   background-color: ${({ hover }) => (hover ? '#fff' : 'transparent')};
  background-color: '#fff';

  @media screen and (max-width: 992px) {
    width: 72px;
    height: 52px;
    width: 52px;
    height: 52px;
  }
`;

export const Icon = styled.div<{ icon: string; isActive?: boolean }>`
  width: 32px;
  height: 32px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(${({ icon }) => icon});
  transition: color 0.3s ease;
  ${({ isActive }) =>
        isActive &&
        css`
      color: #fff;
      filter: grayscale(100%) brightness(0) invert(1);
    `}
`;

export const SidebarItemText = styled.span<{ isOpen: boolean }>`
  transition: color 0.3s ease;
  color: var(--Brand-white-500, #fff);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: 'Aeonik';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  display: flex;
  height: 24px;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
`;

export const SubMenuContainer = styled.ul``;

export const IconWrapper = styled.div`
  position: relative;
  display: flex; align-items: center; justify-content: center;

  display: flex; align-items: center; justify-content: center;

`;
